import React from 'react';

const Header = (props) => {
  const classes = 'flex flex-col text-center w-full';

  if (!props.area) {
    return (
      <div
        className={props.isLoggedin ? `${classes} mb-10` : `${classes} mb-20`}
      >
        <>
          <h1 className="sm:text-3xl text-2xl font-semibold title-font mb-4 text-accent-500">
            My Garden
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
            A database of all my plants. Come explore the world of green.
          </p>
        </>
      </div>
    );
  }

  return (
    <div className={props.isLoggedin ? `${classes} mb-10` : `${classes} mb-20`}>
      <h2 className="text-xs text-accent-500 tracking-widest font-medium title-font mb-[0.65rem]">
        Plants From
      </h2>
      <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
        {props.area.name}
      </h1>
    </div>
  );
};

export default Header;
